// extracted by mini-css-extract-plugin
export default {"control":"Controls_control__3GUPG","audio":"Controls_audio__YQW68","video":"Controls_video__5J3NP"};